import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@src/common';
import { HelpOther } from '@/common/helper';

class Store {
  constructor() {
    makeAutoObservable(this);
  }

  loaded = false;
  list = []; // 邀请码列表
  npt = ''; // 分页标识
  maxInviteCount = 0; // 邀请码最大使用次数
  invitedCount = 0; // 邀请码已使用次数

  /** 获取邀请码列表 */
  getInviteCodeList = ({ init } = {}) => {
    // npt不为空, 表示还有数据,  返回空就不用继续往后翻页了
    if (!this.npt && !init) return;

    request
      .get('/invitation/list', {
        params: {
          npt: this.npt,
        },
      })
      .then(res => {
        if (res?.code != 0) {
          HelpOther.toast(res.msg, 'error');
        }
        
        const { list = [], npt, total_max_uses, total_used_count } = res?.data || {};
        runInAction(() => {
          this.loaded = true;
          this.list = [...this.list, ...list];
          this.npt = npt;
          if (init) {
            this.maxInviteCount = total_max_uses;
            this.invitedCount = total_used_count;
          }
        });
      })
      .catch(e => {
        HelpOther.toast(e.msg, 'error');
      });
  };


  reset() {
    this.loaded = false;
    this.list = [];
    this.npt = '';
    this.maxInviteCount = 0;
    this.invitedCount = 0;
  }
}

export default new Store();
